/**
 * React bootstrap. Bridges the HTML entrypoint to the React component tree.
 *
 * Lives in entrypoints/ because it's plumbing you set once and rarely touch.
 * The HMR guard exists because Tauri's WKWebView on iOS doesn't provide
 * import.meta.hot, and accessing it without a guard crashes silently.
 * Reusing the root across hot updates preserves component state like
 * form inputs and scroll position.
 */
import { createRoot } from "react-dom/client";
import { App } from "../App";

const hmr = import.meta.hot;
const root = hmr
  ? (hmr.data.root ??= createRoot(document.getElementById("root")!))
  : createRoot(document.getElementById("root")!);

root.render(<App />);
